var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeviceTablet = function SvgIconDeviceTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 4.5v15A2.5 2.5 0 0 0 6 22h12a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 18 2H6a2.5 2.5 0 0 0-2.5 2.5m15 0A.5.5 0 0 0 18 4H6a.5.5 0 0 0-.5.5v1.25h13zm0 11.75v-8.5h-13v8.5zm-13 2h13v1.25a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDeviceTablet;